"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LoadingMessage = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _LogoIconSvg = require("../Logos/LogoIconSvg");
require("./loadingMessage.scss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const LoadingMessage = _ref => {
  let {
    message = 'Just a brief paws while we fetch something...',
    customSpinner
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "loadingMessage"
  }, /*#__PURE__*/_react.default.createElement("h1", null, message), customSpinner ? /*#__PURE__*/_react.default.createElement("span", null, customSpinner) : /*#__PURE__*/_react.default.createElement(_LogoIconSvg.LogoIconSvg, null));
};
exports.LoadingMessage = LoadingMessage;
LoadingMessage.propTypes = {
  message: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  customSpinner: _propTypes.default.element
};
var _default = exports.default = LoadingMessage;